export default __webpack_public_path__ + "static/media/company-name.4f919ba5.svg";